// SPS tenant light theme — colors sourced from Figma "Southern Pipe" design file (SPS Light mode).
import { createTheme } from '@mui/material/styles';
import './tokens';

const spsTheme = createTheme({
  cssVariables: true,
  palette: {
    primary: {
      main: '#F75E56',
      contrastText: '#ffffff',
    },
    navigation: {
      background:        '#3d434b',
      subPanelBg:        '#f7f8f9',
      divider:           'rgba(255, 255, 255, 0.2)',
      tabSelectedBg:     '#f7433a',
      tabSelectedBorder: '#ffffff',
      link:              '#f7433a',
      badge:             '#f73a5b',
      text:              '#ffffff',
      textMuted:         'rgba(255, 255, 255, 0.7)',
      subPanelText:      '#2a2e42',
      subPanelTextMuted: 'rgba(42, 46, 66, 0.6)',
      subPanelAvatarBg:  '#d9dce0',
    },
    surface: {
      appBackground:    '#f7f8f9',
      chatPanelBg:      '#ffffff',
      chatHeaderBg:     '#ffffff',
      inputBg:          '#ffffff',
      inputBorder:      '#d9dce0',
      inputBorderFocus: '#f7433a',
      inputText:        '#2a2e42',
      divider:          'rgba(0, 0, 0, 0.08)',
      primaryText:      '#2a2e42',
      secondaryText:    '#8e97a3',
      emptyStateIcon:   '#8e97a3',
      toastBg:          '#3d434b',
      toastText:        '#ffffff',
    },
    chat: {
      userBubbleBg:          '#ECEEF0',
      userBubbleText:        '#2A2E42',
      assistantBubbleBg:     '#D9DCE0',
      assistantBubbleBorder: '#D9DCE0',
      bubbleText:            '#2A2E42',
      sentStatus:            '#9AA0A6',
      reactionAction:        '#8E97A3',
      reactionActionHover:   '#F75E56',
      systemBubbleBg:        '#D9DCE0',
    },
  },
  typography: {
    fontFamily: "'Proxima Nova', sans-serif",
  },
});

export default spsTheme;
